export default "__VITE_ASSET__mdbH_fSX__"